import type { Category } from 'packages/swf-help/center/src/types';
import React from 'react';
import { useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import Translation from '@swf/components/Translation/Translation';
import Account from '@swf/core/assets/icons//alternates/account.svg';
import TechnicalSupport from '@swf/core/assets/icons//alternates/technical-support.svg';
import DepositWithdrawals from '@swf/core/assets/icons/alternates/deposit-withdraw.svg';
import Casino from '@swf/core/assets/icons/alternates/live-casino.svg';
import MyRewards from '@swf/core/assets/icons/alternates/my-rewards.svg';
import PlayMoneySocialGames from '@swf/core/assets/icons/alternates/play-money-social-games.svg';
import ResponsibleGaming from '@swf/core/assets/icons/alternates/responsible-game-help.svg';
import SpecialOffer from '@swf/core/assets/icons/alternates/special-offer.svg';
import { RoutingKey } from '@swf/core/enums';
import { select } from '@swf/core/store';

import { getVertical } from '../../../../utils';

import { TXTWCL_Need_more_N0_helpX } from './CategoryBoard.messages.json';
import styles from './CategoryBoard.scss';

export interface Props {
  categories?: Category[];
}

const icons = {
  'stars-account': <Account />,
  'special-offers': <SpecialOffer />,
  'technical-support': <TechnicalSupport />,
  'responsible-gaming': <ResponsibleGaming />,
  poker: <Casino />,
  casino: <Casino />,
  'deposit-withdrawal': <DepositWithdrawals />,
  sports: <Casino />,
  'play-money': <PlayMoneySocialGames />,
  vegas: <Casino />,
  'vip-club': <MyRewards />,
  'daily-fantasy-sports': <Casino />,
  events: <TechnicalSupport />
};

const CategoryBoard: React.FC<Props> = ({ categories }) => {
  const vertical = getVertical(useSelector(select.page.getVertical));

  return (
    <div className={styles.container}>
      <h2 className={styles.header}>
        <Translation values={{ 0: vertical }} {...TXTWCL_Need_more_N0_helpX} />
      </h2>
      <ul className={styles.content}>
        {categories?.map((category) => (
          <li key={category.id} className={styles.block}>
            <Link route={RoutingKey.HelpCenterCategoryArticles} values={{ category: category.id }}>
              {icons[category.id]}
              <span className={styles.title}>{category.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryBoard;
